import baseCharacterMaleIdleAnimationAsset from "@assets/base_character_v2/animations/idle_male.fbx";
import warriorMaleIdleAnimationAsset from "@assets/base_character_v2/animations/warrior_idle_male.fbx";
import rogueMaleIdleAnimationAsset from "@assets/base_character_v2/animations/rogue_idle_male.fbx";
import mageMaleIdleAnimationAsset from "@assets/base_character_v2/animations/mage_idle_male.fbx";
import baseCharacterMaleWalkAnimationAsset from "@assets/base_character_v2/animations/walk_male.fbx";
import baseCharacterMaleJumpAnimationAsset from "@assets/base_character_v2/animations/jump_male.fbx";
import baseCharacterMaleDeathAnimationAsset from "@assets/base_character_v2/animations/death_male.fbx";
import baseCharacterMaleHorizontalSlashAnimationAsset from "@assets/base_character_v2/animations/horizontal_slash_male.fbx";
import baseCharacterMaleAttack360AnimationAsset from "@assets/base_character_v2/animations/attack_360_male.fbx";
import baseCharacterMaleVerticalSlashAnimationAsset from "@assets/base_character_v2/animations/vertical_slash_male.fbx";
import baseCharacterMaleNinjaRunAnimationAsset from "@assets/base_character_v2/animations/ninja_run_male.fbx";
import baseCharacterMaleNinjaIdleAnimationAsset from "@assets/base_character_v2/animations/ninja_idle_male.fbx";
import baseCharacterMaleOneHandedWeaponRunAnimationAsset from "@assets/base_character_v2/animations/one_handed_weapon_run_male.fbx";
import baseCharacterMaleTwoHandedWeaponIdleAnimationAsset from "@assets/base_character_v2/animations/two_handed_weapon_idle_male.fbx";
import baseCharacterMaleTwoHandedWeaponRunAnimationAsset from "@assets/base_character_v2/animations/two_handed_weapon_run_male.fbx";
import baseCharacterFemaleIdleAnimationAsset from "@assets/base_character_v2/animations/idle_female.fbx";
import warriorFemaleIdleAnimationAsset from "@assets/base_character_v2/animations/warrior_idle_female.fbx";
import rogueFemaleIdleAnimationAsset from "@assets/base_character_v2/animations/rogue_idle_female.fbx";
import mageFemaleIdleAnimationAsset from "@assets/base_character_v2/animations/mage_idle_female.fbx";
import baseCharacterFemaleWalkAnimationAsset from "@assets/base_character_v2/animations/walk_female.fbx";
import baseCharacterFemaleJumpAnimationAsset from "@assets/base_character_v2/animations/jump_female.fbx";
import baseCharacterFemaleDeathAnimationAsset from "@assets/base_character_v2/animations/death_female.fbx";
import baseCharacterFemaleHorizontalSlashAnimationAsset from "@assets/base_character_v2/animations/horizontal_slash_female.fbx";
import baseCharacterFemaleAttack360AnimationAsset from "@assets/base_character_v2/animations/attack_360_female.fbx";
import baseCharacterFemaleVerticalSlashAnimationAsset from "@assets/base_character_v2/animations/vertical_slash_female.fbx";
import baseCharacterFemaleNinjaRunAnimationAsset from "@assets/base_character_v2/animations/ninja_run_female.fbx";
import baseCharacterFemaleNinjaIdleAnimationAsset from "@assets/base_character_v2/animations/ninja_idle_female.fbx";
import baseCharacterFemaleOneHandedWeaponRunAnimationAsset from "@assets/base_character_v2/animations/one_handed_weapon_run_female.fbx";
import baseCharacterFemaleTwoHandedWeaponIdleAnimationAsset from "@assets/base_character_v2/animations/two_handed_weapon_idle_female.fbx";
import baseCharacterFemaleTwoHandedWeaponRunAnimationAsset from "@assets/base_character_v2/animations/two_handed_weapon_run_female.fbx";
import baseCharacterMaleMagicAttackOneHandedAnimationAsset from "@assets/base_character_v2/animations/magic_attack_one_handed_male.fbx";
import baseCharacterFemaleMagicAttackOneHandedAnimationAsset from "@assets/base_character_v2/animations/magic_attack_one_handed_female.fbx";
import baseCharacterStaffMaleRunAnimationAsset from "@assets/base_character_v2/animations/staff_run_male.fbx";
import baseCharacterStaffFemaleRunAnimationAsset from "@assets/base_character_v2/animations/staff_run_female.fbx";

export const BaseMaleCharacterAnimationAssetMap = {
  baseCharacterMaleIdleAnimation: {
    fileName: baseCharacterMaleIdleAnimationAsset,
  },
  warriorMaleIdleAnimation: {
    fileName: warriorMaleIdleAnimationAsset,
  },
  rogueMaleIdleAnimation: {
    fileName: rogueMaleIdleAnimationAsset,
  },
  mageMaleIdleAnimation: {
    fileName: mageMaleIdleAnimationAsset,
  },
  baseCharacterMaleWalkAnimation: {
    fileName: baseCharacterMaleWalkAnimationAsset,
  },
  baseCharacterMaleJumpAnimation: {
    fileName: baseCharacterMaleJumpAnimationAsset,
  },
  baseCharacterMaleDeathAnimation: {
    fileName: baseCharacterMaleDeathAnimationAsset,
  },
  baseCharacterMaleHorizontalSlashAnimation: {
    fileName: baseCharacterMaleHorizontalSlashAnimationAsset,
  },
  baseCharacterMaleAttack360Animation: {
    fileName: baseCharacterMaleAttack360AnimationAsset,
  },
  baseCharacterMaleVerticalSlashAnimation: {
    fileName: baseCharacterMaleVerticalSlashAnimationAsset,
  },
  baseCharacterMaleNinjaRunAnimation: {
    fileName: baseCharacterMaleNinjaRunAnimationAsset,
  },
  baseCharacterMaleNinjaIdleAnimationAsset: {
    fileName: baseCharacterMaleNinjaIdleAnimationAsset,
  },
  baseCharacterMaleOneHandedWeaponRunAnimation: {
    fileName: baseCharacterMaleOneHandedWeaponRunAnimationAsset,
  },
  baseCharacterMaleTwoHandedWeaponIdleAnimation: {
    fileName: baseCharacterMaleTwoHandedWeaponIdleAnimationAsset,
  },
  baseCharacterMaleTwoHandedWeaponRunAnimation: {
    fileName: baseCharacterMaleTwoHandedWeaponRunAnimationAsset,
  },
  baseCharacterMaleMagicAttackOneHandedAnimation: {
    fileName: baseCharacterMaleMagicAttackOneHandedAnimationAsset,
  },
  baseCharacterStaffMaleRunAnimation: {
    fileName: baseCharacterStaffMaleRunAnimationAsset,
  },
} as const;

export const BaseFemaleCharacterAnimationAssetMap = {
  baseCharacterFemaleIdleAnimation: {
    fileName: baseCharacterFemaleIdleAnimationAsset,
  },
  warriorFemaleIdleAnimation: {
    fileName: warriorFemaleIdleAnimationAsset,
  },
  rogueFemaleIdleAnimation: {
    fileName: rogueFemaleIdleAnimationAsset,
  },
  mageFemaleIdleAnimation: {
    fileName: mageFemaleIdleAnimationAsset,
  },
  baseCharacterFemaleWalkAnimation: {
    fileName: baseCharacterFemaleWalkAnimationAsset,
  },
  baseCharacterFemaleJumpAnimation: {
    fileName: baseCharacterFemaleJumpAnimationAsset,
  },
  baseCharacterFemaleDeathAnimation: {
    fileName: baseCharacterFemaleDeathAnimationAsset,
  },
  baseCharacterFemaleHorizontalSlashAnimation: {
    fileName: baseCharacterFemaleHorizontalSlashAnimationAsset,
  },
  baseCharacterFemaleAttack360Animation: {
    fileName: baseCharacterFemaleAttack360AnimationAsset,
  },
  baseCharacterFemaleVerticalSlashAnimation: {
    fileName: baseCharacterFemaleVerticalSlashAnimationAsset,
  },
  baseCharacterFemaleNinjaRunAnimation: {
    fileName: baseCharacterFemaleNinjaRunAnimationAsset,
  },
  baseCharacterFemaleNinjaIdleAnimationAsset: {
    fileName: baseCharacterFemaleNinjaIdleAnimationAsset,
  },
  baseCharacterFemaleOneHandedWeaponRunAnimation: {
    fileName: baseCharacterFemaleOneHandedWeaponRunAnimationAsset,
  },
  baseCharacterFemaleTwoHandedWeaponIdleAnimation: {
    fileName: baseCharacterFemaleTwoHandedWeaponIdleAnimationAsset,
  },
  baseCharacterFemaleTwoHandedWeaponRunAnimation: {
    fileName: baseCharacterFemaleTwoHandedWeaponRunAnimationAsset,
  },
  baseCharacterFemaleMagicAttackOneHandedAnimation: {
    fileName: baseCharacterFemaleMagicAttackOneHandedAnimationAsset,
  },
  baseCharacterStaffFemaleRunAnimation: {
    fileName: baseCharacterStaffFemaleRunAnimationAsset,
  },
};
